import { AbstractSearchCriteria } from './abstract-search-criteria';

export class LocationGroupsSearchCriteria extends AbstractSearchCriteria {
    code: string = '';
    locationCode: string = '';
    name: string = '';
    routeCode: string = '';
}
